import { useLang } from "@/i18n/LangContext";
import { Link } from "react-router-dom";

/** Official Hotel Ciutat Martorell wordmark. `light` = version for dark backgrounds. */
export function Logo({ light = false, compact = false, className = "" }) {
  const { path } = useLang();
  const src = light ? "/images/logo-light.png" : "/images/logo.png";
  return (
    <Link to={path("home")} aria-label="Hotel Ciutat Martorell" data-testid="site-logo" className={`inline-flex items-center ${className}`}>
      <img
        src={src}
        alt="Hotel Ciutat Martorell"
        className={`w-auto ${compact ? "h-9" : "h-11 md:h-[52px]"} transition-opacity duration-300`}
      />
    </Link>
  );
}
